export default __webpack_public_path__ + "static/media/join-embedded@2x.b8fcc62a.jpg";